import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { ModuleFormValues } from "src/models/Module.model";
import ModuleForm from "../Layouts/ModuleForm";
import {
  useEditModuleMutation,
  useViewModuleQuery,
} from "src/services/ModuleServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  moduleId: string;
};

const EditModuleFormWrapper = ({ onClose, moduleId }: Props) => {
  const [moduleData, setModuleData] = useState<any>();

  const { data, isLoading, isFetching } = useViewModuleQuery(moduleId);
  const [editModule] = useEditModuleMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setModuleData(data?.data);
    }
  }, [isFetching, isLoading, data]);

  // Form Initial Values
  const initialValues: ModuleFormValues = {
    moduleName: moduleData?.moduleName,
    chapterId: moduleData?.chapterId?.map((el: any) => {
      return {
        label: el?.chapterName,
        value: el?._id,
      };
    }),
  };

  // Validation Schema
  const validationSchema = object().shape({
    moduleName: string().required("Please enter module name"),
    chapterId: array().required("Please enter chapters"),
  });

  //API

  // Handle Submit
  const handleSubmit = (
    values: ModuleFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ModuleFormValues>
  ) => {
    const formattedValues = {
      moduleName: values?.moduleName,
      chapterId: values?.chapterId?.map((chapter: any) => chapter.value),
    };
    editModule({
      body: formattedValues,
      id: moduleId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ModuleForm
              formType="EDIT"
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditModuleFormWrapper;
